export const volumeHigh = {
	className: 'icon-volume-high',
	viewBox: '0 0 384 384',
	paths: ['M 0,128 0,256 85.334,256 192,367.543 192,16.458 85.334,128 0,128 Z m 288,64 c 0,-38.399 -21.333,-72.407 -53.333,-88.863 l 0,176.636 C 266.667,264.408 288,230.4 288,192 Z M 234.667,0 l 0,44.978 c 61.864,18.654 106.667,77.904 106.667,147.022 0,69.119 -44.803,128.369 -106.667,147.022 l 0,44.978 C 320,364.254 384,285.257 384,192 384,98.744 320,19.746 234.667,0 Z']
}
